import React from 'react'
import * as Yup from 'yup'
import { FieldArray, Form, Formik } from 'formik'
import { Drawer } from '@components/Drawer'
import InputField from '@components/form/InputField/InputField'
import { ordinalNumbers } from '@libs/utils'
import { DrawerContext } from '@hooks/useDrawer'
import { CoverSpreadsForm } from '@models/Bot/CoverSpreadsForm'
import PrimaryButton from '@components/buttons/PrimaryButton'
import { requiredNumberMsg } from '@constant/errorMessage'
import { Bot } from '@models/Bot/Bot'

const validationSchema = Yup.object().shape({
  coverSpreads: Yup.array().of(
    Yup.object().shape({
      value: Yup.number()
        .required(requiredNumberMsg)
        .test({
          name: 'min-value',
          test: (value, ctx) => {
            if ((value ?? 0) <= 0) {
              return ctx.createError({
                path: ctx.path,
                message: `Value must have minimum value at 0`,
              })
            }
            return true
          },
        }),
      isTrends: Yup.boolean().required(),
    })
  ),
})

const CoverSpreadsDrawer = ({
  drawer,
  onSubmit,
  initialValues,
  bot,
}: {
  bot?: Bot | null
  drawer: DrawerContext
  onSubmit: (form) => void
  initialValues: CoverSpreadsForm
}) => {
  return (
    <>
      <Drawer
        isDrawerOpen={drawer.isDrawerOpen}
        handleClickClose={drawer.handleClickClose}
        header='Covering spreads'
      >
        {drawer.isDrawerOpen && (
          <div className='max-w-[700px] mx-auto'>
            <Formik
              initialValues={initialValues}
              onSubmit={form => {
                onSubmit(form)
                drawer.handleClickClose()
              }}
              validationSchema={validationSchema}
            >
              {({ values }) => (
                <Form>
                  <FieldArray
                    name='coverSpreads'
                    render={() => (
                      <>
                        {values.coverSpreads?.map((coverSpread, i) => (
                          <div key={i} className='flex items-center py-[12px]'>
                            <div className='flex-1'>{`${ordinalNumbers(
                              i + 1
                            )} Covering spread`}</div>
                            <InputField
                              {...(bot && { disabled: i < bot.coverRound })}
                              type='number'
                              name={`coverSpreads.${i}.value`}
                              className='w-[160px]'
                              showErrorMessage
                              showErrorWithoutTouched
                              rightIcon={
                                <span className='text-sm font-medium'>%</span>
                              }
                            />
                            {/* <div className='flex-1 flex justify-end'>
                              <ToggleSwitchField
                                name={`coverSpreads.${i}.isTrends`}
                              />
                            </div> */}
                          </div>
                        ))}
                      </>
                    )}
                  />
                  <PrimaryButton
                    type='submit'
                    className='w-full mt-[20px] rounded-[18px]'
                  >
                    Confirm
                  </PrimaryButton>
                </Form>
              )}
            </Formik>
          </div>
        )}
      </Drawer>
    </>
  )
}

export default CoverSpreadsDrawer
